export const fieldIsRequired = (label: string) => {
	return "label is required".replace("label", label);
};

export const minValue = (label: string, number: number) => {
	return `label must be greater than or equal to ${number}`.replace("label", label);
};

export const fieldIsNotEmpty = (label: string) => {
	return "label can't be empty.".replace("label", label);
};
